var _path, _ellipse, _ellipse2, _script;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgCircleDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1013,
    height: 900,
    viewBox: "0 0 1013 900",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M613.5 -34H1145V961H613.5H612V960.998C337.928 960.189 116 737.761 116 463.5C116 189.239 337.928 -33.1889 612 -33.9978V-34H613.5Z",
    fill: "#FBF7FF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 613.5,
    cy: 463.5,
    rx: 552.5,
    ry: 553.5,
    fill: "#F7EBFF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    cx: 613.5,
    cy: 476.5,
    rx: 600.5,
    ry: 601.5,
    fill: "#F7EBFF"
  })), _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: "",
    type: "text/javascript",
    src: "chrome-extension://hejbmebodbijjdhflfknehhcgaklhano/../window/testing-library.js"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgCircleDesktop);
export default __webpack_public_path__ + "static/media/bg-circle-desktop.4781c74e518a8a60fdd5d256cb7650d1.svg";
export { ForwardRef as ReactComponent };